import { createStore, applyMiddleware, compose } from 'redux';
import logger from 'redux-logger';
import thunk from 'redux-thunk';
import promise from 'redux-promise';

import reducers from 'reducers';

const middleware = [promise, thunk];

if (process.env.NODE_ENV === 'development') {
  middleware.push(logger);
}

const store = compose(applyMiddleware(...middleware))(createStore)(reducers,
window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());

export default store;
